<template>
  <div class="container">
    <!-- 数据列表 -->
    <template v-if="activityDetails && activityDetails.actId">
      <div class="shop_list" ref="wrapper">
        <div class="wrapper">
          <div class="top">
            <img
              v-if="activityDetails.actImg"
              :src="activityDetails.actImg"
              @click="viewBigPic(activityDetails.actImg)"
              alt="logo"
              class="topImage"
            />
            <p
              v-if="(activityDetails.statusCN=='进行中'&&(timestamp<activityDetails.signBegTime||timestamp>activityDetails.signEndTime))||(activityDetails.statusCN=='进行中'&&!activityDetails.signBegTime&&!activityDetails.signEndTime)||activityDetails.statusCN!=='报名中'"
              :class="['status_line',activityDetails.statusCN=='未开始'?'activety':'',activityDetails.statusCN=='已结束'?'activetyEd':'',activityDetails.statusCN=='进行中'?'activetyIng':'']"
            >{{activityDetails.statusCN}}</p>
            <div class="status_line status_ing" v-else>
              <span class="ing_left">{{activityDetails.statusCN}}</span>
              <span class="ing_right">{{distanceTime}}</span>
            </div>
            <!-- <p v-if="activityDetails.actINGType ==1" class="status_line status_end">{{activityDetails.statusCN}}</p> -->
            <div class="prices">
              <div class="prices1">
                <span v-if="activityDetails.isFree == 1 " class="price0">免费</span>
                <span v-if="activityDetails.isFree !== 1" class="price">￥</span>
                <span
                  v-if="activityDetails.isFree !== 1"
                  class="price1"
                >{{activityDetails.actPrice}}</span>
              </div>
              <span class="seeCounts">{{'浏览 ' + visitNumber +'次'}}</span>
              <img @click="shareFun" src="../../assets/images/icon_share.png" class="icon_share" />
            </div>
            <div class="titleDiv" v-if="activityDetails.actTitle">
              <span class="titleSpan">{{activityDetails.actTitle }}</span>
            </div>
            <div class="actLabels" v-if="actLabel">
              <span v-for="(item,index) in actLabel" :key="index" class="actLabel"># {{item}}</span>
            </div>
          </div>
          <div class="ActiveBody">
            <div class="Activetime border-bottom">
              <img src="../../assets/images/time.png" class="left_icon" />
              <span
                class="timeTitle"
              >时间：{{ date(activityDetails.actBegTime) }} 至 {{date(activityDetails.actEndTime)}}</span>
            </div>
            <div class="Activetime border-bottom">
              <!-- <span class="iconfont">&#xe611;</span> -->
              <img src="../../assets/images/icon_site.png" class="left_icon" />
              <span class="timeTitle">地址：{{activityDetails.actAddress}}</span>
              <img
                src="../../assets/images/btn_duplicate.png"
                class="btn_duplicate"
                @click="copyTradeCode"
                :data-clipboard-text="activityDetails.actAddress"
              />
            </div>
            <div class="Activetime" v-if="activityDetails.isRegForm != 2">
              <!-- <span class="iconfont">&#xe614;</span> -->
              <!-- <img src="../../assets/images/act_icon_member.png" class="timeImage"> -->
              <img src="../../assets/images/icon_member.png" class="left_icon" />
              <span class="timeTitle">名额：{{actMaxPerson}}人</span>
            </div>

            <!-- <div
              class="content_3"
              v-if="activityDetails.signNumber==0 && activityDetails.isRegForm != 2
                && activityDetails.statusCN != '未开始'"
            >
              <div class="headePic">
                <span class="content_3_text2">-0人已经报名-</span>
              </div>
            </div>-->
            <div
              class="content_3"
              v-if="activityDetails.signNumber>8 && activityDetails.isRegForm != 2"
            >
              <div class="headePic">
                <img
                  class="headePic_url"
                  :src="item ?item:require(`../../assets/images/img_default_face_${common.theme}.jpg`)"
                  v-for="(item,index) in imgPaths"
                  :key="index"
                />
              </div>
              <div class="headePic" v-if="activityDetails.signNumber>8">
                <!-- <span class="content_3_text1">{{activityDetails.signNumber}}</span> -->
                <span class="content_3_text2">{{activityDetails.signNumber}}人已报名</span>
              </div>
            </div>
          </div>

          <div class="Notice" v-if="activeRules.length>0">
            <span class="NoticeTitle border-bottom">退款规则</span>
            <div v-for="(item,index) in activeRules" :key="index">
              <div class="activeRulesBox">
                <span class="activeRulesLeft" v-if="activeRules.length !== 1">{{index + 1}}.</span>
                <span
                  class="activeRulesRight"
                >截至活动开始前{{item.ruleTime}}天取消订单，退还该订单总金额的{{item.refundRatio}}%</span>
              </div>
            </div>
          </div>

          <div class="Notice" v-if="html">
            <span class="NoticeTitle border-bottom">活动详情</span>
            <div class="html" v-html="html"></div>
          </div>
        </div>
      </div>
      <common-footer class="button" v-if="hasButton">
        <button class="btn_zx" @click="callPhone">
          <div class="btn_zx_body">
            <img
              :src="require(`../../assets/images/icon_phone_${common.theme}.png`)"
              class="btn_zx_icon"
            />
            活动咨询
          </div>
        </button>
        <button v-if="actState == '报名进行中'" class="btn_bm" @click="goToPost">我要报名</button>
        <button v-else class="btn_bm_gray">{{actState}}</button>
      </common-footer>

      <common-footer class="button" v-else>
        <button :class="['btn_zx1','btn_color_'+common.theme]" @click="callPhone">活动咨询</button>
      </common-footer>
    </template>
    <div v-if="!(activityDetails && activityDetails.actId) && showPage" class="noMess">
      <img src="../../assets/images/img_unpublish.png" />
      <span>该活动已下架</span>
      <!-- <span class="btn" bindtap="toIndex">返回首页</span> -->
    </div>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary :imgs="imgsArr" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
    <share-iframe :showIframe="showIframe" @hideIframe="hideIframe"></share-iframe>
  </div>
</template>

<script>
import { getActiveDetailById } from '../../utils/api';
import util from '../../utils/util';
import ShareIframe from '../../components/shareIframe';
import commonFooter from '../../components/commonFooter';
import { mapState } from 'vuex';
import CommonGallary from '../../components/Gallary';
import FadeAnimation from '../../components/FadeAnimation';
import Clipboard from 'clipboard';
 import wx from 'weixin-js-sdk';
//import wx from 'jweixin-1.6.0'
export default {
  name: 'activityDetails',
  components: {
    // commonHeader,
    commonFooter,
    CommonGallary,
    FadeAnimation,
    ShareIframe
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      dataList: [],
      imgPaths: [],
      activityDetails: {},
      hasButton: false,
      activeID: '',
      detailOrNotice: true,
      actLabel: '',
      distanceTime: '',
      hour: '',
      minute: '',
      signNumber: '',
      actMaxPerson: '',
      alreadyReg: '',
      actState: '',
      visitNumber: '',
      requested: false,
      actId: '',
      htmlStr: '',
      width: 716,
      height: 200,
      widthNotice: 750,
      heightNotice: 200,
      htmlStrNotice: '',
      html: '',
      isRegForm: '',
      orderId: '',
      noForm: '212121212121',
      activeRules: '',
      activeInfo: {},
      actImg64: '',
      canGoBack: false,
      timestamp: '',
      currentDate: '',
      showGallary: false,
      imgsArr: [],
      showPage: false,
      showIframe: false,
      webHeight: {
        height: '800px'
      },
      timer: null,
      allLoaded: false, // 可以进行上拉
      loaded: false
    };
  },
  created() {
  },
  activated() {
    if (this.activeID !== this.$route.params.id) {
      this.activeID = this.$route.params.id;
      this.getActiveDetailByIdAction();
    }
  },
  filters: {
  },
  methods: {
    shareFun() {
      this.showIframe = true
    },
    hideIframe() {
      this.showIframe = false
    },
    handleGallaryClose() {
      this.showGallary = false
    },
    viewBigPic(pic) {
      this.imgsArr = [];
      this.imgsArr.push(pic)
      this.showGallary = true;
    },
    copyTradeCode() {
      var clipboard = new Clipboard('.btn_duplicate')
      clipboard.on('success', () => {
        util.showToast('复制成功')
        // 释放内存
        clipboard.destroy()
      })
    },
    callPhone() {
      if (!this.activityDetails.contactNumber) {
        util.showToast('该活动不支持电话咨询，敬请谅解');
      } else {
        window.location.href = 'tel://' + this.activityDetails.contactNumber;
      }
    },
    goToPost() {
      if (!this.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: `/activityForm/${this.activeID}`
          }
        })
      } else {
        this.$router.push(`/activityForm/${this.activeID}`);
      }
    },
    date(value) {
      var Begdate = new Date(value);
      var Begyear = Begdate.getFullYear();
      var Begmonth = Begdate.getMonth() + 1;
      Begmonth = this.formatNumber(Begmonth);
      var Begday = Begdate.getDate();
      Begday = this.formatNumber(Begday);
      var Beghous = Begdate.getHours();
      Beghous = this.formatNumber(Beghous);
      var BegMinutes = Begdate.getMinutes();
      BegMinutes = this.formatNumber(BegMinutes);
      // var Seconds = Begdate.getSeconds();
      var str =
        Begyear +
        '-' +
        Begmonth +
        '-' +
        Begday +
        ' ' +
        Beghous +
        ':' +
        BegMinutes;

      return str;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : '0' + n;
    },
    // 活动详情
    getActiveDetailByIdAction() {
      let that = this;
      let params = {
        activeId: this.$route.params.id,
        userId: ''
      };
      getActiveDetailById(params, {
        cityId: this.common.marketInfo.cityId,
        userId: this.common.userId
      }).then(res => {
        console.log(res)
        this.showPage = true;
        util.hideLoading()
        var _this = this;
        this.loaded = true;
        if (res.res.code === 10000) {
          this.imgPaths = res.body.imgPaths;
          var arr = [];
          var num = this.imgPaths.length > 8 ? 8 : this.imgPaths.length;
          for (var i = 0; i < num; i++) {
            arr.push(this.imgPaths[i]);
          }
          this.imgPaths = arr;

          this.activityDetails = res.body.activeInfo;
          if (this.activityDetails.statusCN === '未开始') {
            this.activityDetails.actINGType = 1;
          } else if (this.activityDetails.statusCN === '已结束') {
            this.activityDetails.actINGType = 2;
          } else {
            this.activityDetails.actINGType = 0;
          }

          this.dataList.push(this.activityDetails);
          this.activeRules = res.body.activeRules;
          if (res.body.activeInfo.actLabel) {
            this.actLabel = res.body.activeInfo.actLabel.split(';');
          }
          this.signNumber = res.body.activeInfo.signNumber;
          this.actMaxPerson = res.body.activeInfo.actMaxPerson;
          this.alreadyReg = res.body.activeInfo.alreadyReg;
          this.isRegForm = res.body.activeInfo.isRegForm;
          this.visitNumber = res.body.activeInfo.visitNumber;
          this.actId = res.body.activeInfo.actId;

          this.htmlStr = res.body.activeInfo.actDetail
            ? res.body.activeInfo.actDetail
            : '';
          this.htmlStrNotice = res.body.activeInfo.actNotice
            ? res.body.activeInfo.actNotice
            : '';

          this.html = res.body.activeInfo.actDetail
            ? res.body.activeInfo.actDetail
            : '';

          if (!this.activityDetails.signBegTime) {
            this.distanceTime = '';
            this.hasButton = false;
          } else {
            this.hasButton = true;
            var currentTime1 = Date.parse(new Date());
            if (this.activityDetails.signEndTime - currentTime1 <= 0) {
              this.distanceTime = '报名已经结束';
            } else {
              var day1 = parseInt(
                (_this.activityDetails.signEndTime - currentTime1) /
                (1000 * 60 * 60 * 24)
              );
              var hour1 = parseInt(
                (_this.activityDetails.signEndTime - currentTime1) /
                (1000 * 60 * 60) %
                24
              );
              var minute1 = parseInt(
                (_this.activityDetails.signEndTime - currentTime1) /
                (1000 * 60) %
                60
              );
              this.day = day1;
              this.hour = hour1;
              this.minute = minute1;
              if (day1 < 1) {
                _this.distanceTime = '剩' + hour1 + '小时' + minute1 + '分';
              } else {
                _this.distanceTime =
                  '剩' + day1 + '天' + hour1 + '小时' + minute1 + '分';
              }
            }
          }
           let address1 = window.location.href.split('?')[0];
           wx.ready(() => {
             if(that.common.cityId){
                address1 = address1+"?cityId="+that.common.cityId
             }else{
                address1 = address1+'?marketId=' + that.common.marketInfo.id
             }
             console.log("address1  ======  " +  address1)
             console.log("title  ======  " +  that.activityDetails.actTitle)
            let obj = {
              title: that.activityDetails.actTitle, // 分享标题
              desc: '时间:' + that.date(that.activityDetails.actBegTime) + '至' + that.date(that.activityDetails.actEndTime) + ';地址:' + that.activityDetails.actAddress,
              link: address1, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.activityDetails.actImg,// 分享图标
              success: function () {
                that.showIframe = false
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })

          var getDistanceTime = function () {
            if (!_this.hasButton) {
              return;
            }
            var currentTime = Date.parse(new Date());
            if (_this.activityDetails.signEndTime - currentTime <= 0) {
              _this.distanceTime = '报名已经结束';
              if (_this.timer) {
                clearInterval(_this.timer);
                _this.timer = null;
              }
            } else {
              var day = parseInt(
                (_this.activityDetails.signEndTime - currentTime) /
                (1000 * 60 * 60 * 24)
              );
              var hour = parseInt(
                (_this.activityDetails.signEndTime - currentTime) /
                (1000 * 60 * 60) %
                24
              );
              var minute = parseInt(
                (_this.activityDetails.signEndTime - currentTime) /
                (1000 * 60) %
                60
              );
              _this.day = day;
              _this.hour = hour;
              _this.minute = minute;
              if (day < 1) {
                _this.distanceTime = '剩' + hour + '小时' + minute + '分';
              } else {
                _this.distanceTime =
                  '剩' + day + '天' + hour + '小时' + minute + '分';
              }
            }
          };

          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          this.timer = setInterval(() => {
            getDistanceTime();
          }, 1000 * 60);

          if (!_this.hasButton) {
            return;
          }
          var currentTime = Date.parse(new Date());
          this.timestamp = currentTime
          if (
            _this.activityDetails.signBegTime < currentTime &&
            currentTime < _this.activityDetails.signEndTime
          ) {
            _this.actState = '报名进行中';
            _this.activityDetails.statusCN = '报名中';
          }
          if (_this.activityDetails.signBegTime > currentTime) {
            _this.actState = '报名未开始';
          }
          if (currentTime > _this.activityDetails.signEndTime) {
            _this.actState = '报名已结束';
          }
          let address = window.location.href.split('?')[0];
          wx.ready(() => {
            let obj = {
              title: that.activityDetails.actTitle, // 分享标题
              desc: '时间:' + that.date(that.activityDetails.actBegTime) + '至' + that.date(that.activityDetails.actEndTime) + ';地址:' + that.activityDetails.actAddress,
              link: address + '?marketId=' + that.common.marketInfo.id + '&cityId=' + that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.activityDetails.actImg,// 分享图标
              success: function () {
                that.showIframe = false
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        } else {
          util.showToast(res.res.msg)
        }
      });
    }
  }
};
</script>
<style lang="less">
.html * {
  -webkit-touch-callout: auto;
  -webkit-user-select: auto;
  -khtml-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  user-select: auto;
}
</style>
<style lang="less" scoped>
@import "../../assets/css/common.less";
// /deep/ * {
//   -webkit-touch-callout: auto;
//   -webkit-user-select: auto;
//   -khtml-user-select: auto;
//   -moz-user-select: auto;
//   -ms-user-select: auto;
//   user-select: auto;
// }
html,
body {
  min-height: 100vh;
  background: #fff;
}

.content_3 {
  padding-bottom: 28px;
  border-top: 14px solid #f8f8f8;
}
.noMess {
  p {
    margin-top: 200px;
    .fontSize(14px);
    text-align: center;
    color: @color6;
  }
}
.shop_list {
  background: #fff;
  margin-bottom: 138px;
  .top {
    background-color: #fff;
    flex-direction: column;
    width: 100%;
    display: flex;
    .topImage {
      width: 100%;
      height: 508px;
    }
    .status_line {
      height: 68px;
      width: 100%;
      text-align: center;
      font-size: 28px;
      line-height: 68px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .status_end {
      background: #eaeaea;
      color: #999;
    }
    .status_ing {
      background: linear-gradient(
        90deg,
        rgba(100, 0, 255, 1) 0%,
        rgba(246, 28, 126, 1) 100%
      );
      .ing_left {
        width: 150px;
        text-align: center;
        color: #fff;
        margin-right: 20px;
        padding-left: 50px;
        text-align: left;
        background: url("../../assets/images/bg01.png") left center no-repeat;
        background-size: 100% auto;
      }
      .ing_right {
        flex: 1;
        color: #fff;
        text-align: left;
        background: url("../../assets/images/bg02.png") right bottom no-repeat;
        background-size: 92px auto;
      }
    }
    .prices {
      width: 100%;
      flex-direction: row;
      display: inline-flex;
      height: 88px;
      align-items: center;
      justify-content: space-between;

      .prices1 {
        flex-direction: row;
        display: flex;
        height: 88px;
        align-items: center;
        .price {
          margin-left: 24px;
          color: #ff4159;
          height: 54px;
          .fontSize(20px);
          font-weight: bold;
          line-height: 54px;
        }
        .price0 {
          margin-left: 24px;
          color: #333;
          height: 54px;
          .fontSize(16px);
          line-height: 44px;
        }

        .price1 {
          margin-left: 4px;
          color: #ff4f44;
          height: 54px;
          .fontSize(25px);
          font-weight: bold;
          color: rgba(255, 79, 68, 1);
          line-height: 54px;
        }
      }

      .seeCounts {
        padding-right: 28px;
        height: 88px;
        .fontSize(14px);
        color: @color9;
        line-height: 88px;
        text-align: right;
        flex: 1;
        position: relative;
        display: block;
        &:before {
          position: absolute;
          content: "";
          right: 0;
          top: 24px;
          height: 36px;
          width: 2px;
          background: #dadada;
        }
      }
      .icon_share {
        width: 44px;
        height: 44px;
        padding: 22px 28px;
      }
    }

    .titleDiv {
      width: 100%;
      display: flex;
      margin-bottom: 20px;
      .titleSpan {
        margin-left: 28px;
        margin-right: 28px;
        .fontSize(18px);
        font-weight: bold;
        color: @color3;
        line-height: 50px;
      }
    }

    .actLabels {
      .flex();
      flex-wrap: wrap;
      padding-left: 28px;
      margin-bottom: 28px;
      .actLabel {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 0 8px;
        height: 36px;
        line-height: 36px;
        background: rgba(60, 100, 159, 0.1);
        border-radius: 4px;
        font-size: 24px;
        color: #3c649f;
        line-height: 36px;
      }
    }
  }
  .ActiveBody {
    background-color: #fff;
    flex-direction: column;
    width: 100%;
    display: flex;
    .Activetime {
      margin: 0 28px;
      flex-direction: row;
      display: flex;
      padding: 28px 0;
      .timeImage {
        margin-left: 4px;
        margin-top: 5px;
        width: 32px;
        height: 32px;
      }
      .iconfont {
        margin-left: 4px;
        .fontSize(20px);
        color: #ccc;
        display: block;
      }
      .timeTitle {
        flex: 1;
        .fontSize(15px);
        color: @color3;
        line-height: 42px;
        word-break: break-all;
      }
      .left_icon {
        width: 32px;
        height: 32px;
        margin-top: 5px;
        display: block;
        margin-right: 14px;
      }
      .btn_duplicate {
        width: 44px;
        height: 44px;
        margin-left: 14px;
        display: block;
      }
    }
    .content_3 {
      width: 100%;
      flex-direction: column;
      display: flex;

      .headePic {
        margin-top: 26px;
        width: 100%;
        flex-direction: row;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .headePic_url {
        height: 77px;
        width: 77px;
        border-radius: 36.5px;
        margin-left: 6px;
        margin-right: 6px;
        background-color: #f5f5f5;
      }

      .content_3_text1 {
        .fontSize(12px);
        color: @color17;
        line-height: 33px;
      }

      .content_3_text2 {
        .fontSize(12px);
        color: @color9;
        line-height: 33px;
      }
    }
  }

  .Notice {
    background-color: @colorw;
    flex-direction: column;
    width: 100%;
    display: flex;
    border-top: 14px solid #f8f8f8;
    padding-bottom: 25px;
    .NoticeTitle {
      display: block;
      padding: 22px 28px;
      .fontSize(16px);
      font-weight: bold;
      color: rgba(0, 0, 0, 0.9);
      line-height: 44px;
    }

    .activeRulesBox {
      margin-top: 15px;
      margin-bottom: 23px;
      padding-left: 25px;
      padding-right: 25px;

      .activeRulesLeft {
        .fontSize(15px);
        color: @color3;
        line-height: 40px;
      }
      .activeRulesRight {
        .fontSize(15px);
        color: @color3;
        line-height: 40px;
      }
    }
  }

  //   overflow: scroll;
}
.button {
  .btn_zx1 {
    height: 68px;
    .btn();
    border-radius: 4px;
    text-align: center;
    line-height: 68px;
    .fontSize(14px);
    display: block;
    width: 100%;
  }

  .btn_zx {
    margin-right: 20px;
    width: 332px;
    border: 0.015rem solid #96aaf0;
    height: 68px;
    background: rgba(243, 245, 253, 1);
    border-radius: 4px;
    text-align: center;
    line-height: 68px;
    box-sizing: border-box;
    .fontSize(14px);
    color: @color17;
    display: block;
    .btn_zx_body {
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 0 #fff !important;
      .btn_zx_icon {
        width: 30px;
        height: 30px;
        // margin-left: 29px;
        margin-right: 17px;
      }
    }
  }
  .btn_bm {
    width: 332px;
    height: 68px;
    .btn();
    border-radius: 4px;
    text-align: center;
    line-height: 68px;
    .fontSize(14px);
    display: block;
  }

  .btn_bm_gray {
    width: 332px;
    height: 68px;
    .btn();
    border-radius: 4px;
    text-align: center;
    line-height: 68px;
    .fontSize(16px);
    display: block;
    background: #dadada;
  }
}

/* 下拉、上拉提示信息 */
.top-tip {
  position: absolute;
  top: -40px;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #555;
}

.bottom_tip {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #666;
  .fontSize(14px);
}
.html {
  margin-top: 28px;
  padding-left: 25px;
  padding-right: 25px;
  /deep/ p,
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 80%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
.timeTips_text1,
.timeTips_text3 {
  flex: 1;
  background-color: #fff3e8;
  line-height: 68px;
  text-align: center;
  color: #ffad5d;
  font-size: 28px;
}

.timeTips_tWrap {
  flex: 1;
  flex-direction: row;
}

.timeTips_text2 {
  width: 160px;
  background-color: #0087ff;
  color: #ffffff;
  font-size: 28px;
  line-height: 68px;
  text-align: center;
}

.timeTips_text3 {
  font-size: 24px;
  background-color: #dbeeff;
  color: #0087ff;
}

.activety {
  color: #ffad5d;
  background-color: #fff3e8;
}

.activetyIng {
  color: @color17;
  background-color: #dbeeff;
}

.activetyEd {
  color: #999999;
  background-color: #eaeaea;
}
.noMess {
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90vh;
  img {
    display: block;
    width: 280px;
    height: 280px;
    margin-bottom: 28px;
  }
  span {
    color: #999;
    font-size: 32px;
    line-height: 44px;
  }
}
</style>